@let organicMatterReport = organicMatterReport$ | async;
@let organicMatterBenchmark = organicMatterBenchmark$ | async;
@let companyName = companyName$ | async;

<agr-summary-card [actions]="cardActions" [title]="'organicMatterBalanceTitle' | translate" class="list-summary-card">
  @if (isLoading$ | async) {
    <skeleton width="100%" height="250px" />
  } @else if (showError$ | async) {
    <app-empty-widget [text]="'errors.loadOrganicMatterBalanceFailed' | translate" textSize="medium" />
  } @else if (organicMatterReport) {
    <div class="text--bold text--h3 spacing--padding-top">{{ (customer$ | async)?.name }}</div>
    <dl class="spacing--margin-none-top spacing--margin-bottom spacing--padding-top">
      <dt class="text--label spacing--margin-half-bottom">
        {{ 'effectiveOrganicMatterValue' | translate }}
        ({{ 'organicMatterValue' | translate }})
      </dt>
      <dd class="text--bold text--h4">
        {{ organicMatterReport.totals?.organicMatterBalancePerHectare ?? 0 | number: '1.0-0' }}
        {{ 'organicMatterValue' | translate }}
        <span class="text--light text--h5">
          /
          {{ organicMatterBenchmark?.kgOMPerHa ? (organicMatterBenchmark?.kgOMPerHa | number: '1.0-0') : '-' }}</span
        >
      </dd>

      <dt class="text--label spacing--margin-half-bottom">{{ 'year' | translate }}</dt>
      <dd class="text--bold text--h4">{{ cropYear() }}</dd>
    </dl>

    @if (dataSource$ | async) {
      <agr-chart [dataSource]="(dataSource$ | async)!" [options]="(chartOptions$ | async)!" />
    }

    @if (informationTooltipText) {
      <mat-icon [matTooltip]="informationTooltipText" class="information-tooltip"> help_outline </mat-icon>
    }

    <mat-divider />

    <div class="spacing--padding-horizontal spacing--padding-top spacing--margin-half-bottom">
      <div class="text--label">
        <button (click)="openOrganicMatterReportDialog(organicMatterReport, companyName)" mat-button>
          <mat-icon>arrow_forward</mat-icon>
          {{ 'moreDetails' | translate }}
        </button>
      </div>
    </div>
  } @else {
    <agr-notification-empty [isEmpty]="true" />
  }
</agr-summary-card>
